import { useEffect, useRef, useState } from 'react';
import { claveBorrador, guardarBorrador, leerBorrador, borrarBorrador } from '../utils/borradores';

/**
 * Borrador del cierre de una visita del técnico (21-oct-2026): lo que va cargando (equipos, fotos,
 * pago, firmas) queda en el celular. Si se corta la señal, se cierra la app o el navegador recarga
 * la pestaña al sacar una foto, al volver a "Cerrar trabajo" sigue donde estaba.
 *
 * - `nombre`: uno por visita o por trabajo (ej. "cierre_orden_12").
 * - `estado`: lo que se guarda; `aplicar(b)`: vuelve a poner el borrador en la pantalla.
 * Devuelve { recuperado, borrar }.
 */
export default function useBorradorCierre(nombre, estado, aplicar, hayAlgo) {
    const clave = useRef(claveBorrador(nombre)).current;
    const [listo, setListo] = useState(false);       // no guardar antes de leer lo que había
    const [recuperado, setRecuperado] = useState(false);
    const aplicarRef = useRef(aplicar);
    aplicarRef.current = aplicar;

    useEffect(() => {
        let vivo = true;
        leerBorrador(clave)
            .then(b => { if (vivo && b) { aplicarRef.current(b); setRecuperado(true); } })
            .catch(() => {})
            .finally(() => { if (vivo) setListo(true); });
        return () => { vivo = false; };
    }, [clave]);

    // Guardar un rato después de cada cambio (no en cada tecla)
    const json = JSON.stringify(estado);
    useEffect(() => {
        if (!listo) return undefined;
        const t = setTimeout(() => {
            if (hayAlgo) guardarBorrador(clave, JSON.parse(json));
            else borrarBorrador(clave);
        }, 600);
        return () => clearTimeout(t);
    }, [json, listo, hayAlgo, clave]);

    return { recuperado, borrar: () => borrarBorrador(clave) };
}
